import React from "react";

export const CopyUniqueJobId = () => (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">

        <path
            d="M12.2854 2.5H5.10683C5.0479 2.5 4.99969 2.54821 4.99969 2.60714V3.35714C4.99969 3.41607 5.0479 3.46429 5.10683 3.46429H11.7497V12.6786C11.7497 12.7375 11.7979 12.7857 11.8568 12.7857H12.6068C12.6658 12.7857 12.714 12.7375 12.714 12.6786V2.92857C12.714 2.69152 12.5225 2.5 12.2854 2.5ZM10.5711 4.21429H3.71397C3.47692 4.21429 3.2854 4.4058 3.2854 4.64286V11.7504C3.2854 11.8643 3.33094 11.9728 3.41129 12.0531L5.73228 14.3741C5.76174 14.4036 5.79522 14.4277 5.83138 14.4478V14.4732H5.88763C5.93451 14.4906 5.98406 14.5 6.03495 14.5H10.5711C10.8082 14.5 10.9997 14.3085 10.9997 14.0714V4.64286C10.9997 4.4058 10.8082 4.21429 10.5711 4.21429ZM5.83004 13.1098L4.67692 11.9554H5.83004V13.1098ZM10.0354 13.5357H6.68719V11.6339C6.68719 11.3379 6.44745 11.0982 6.15147 11.0982H4.24969V5.17857H10.0354V13.5357Z"
            fill="#1976D2"
        />

    </svg>
);
